import { useEffect, useState } from 'react';

/**
 * A `Date` that re-renders on an interval, so "10:24 PM local time" does not
 * freeze at whatever it said when the card opened. The timer lives and dies
 * with the card, so a closed popover costs nothing.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs]);

  return now;
}
